<template>
  <oms-filter-content
    :title="title"
    :is-filtering="modelValue && Boolean(modelValue.starts_at || modelValue.ends_at)"
  >
    {{ startsAt() || t('features.vue.shared.filters.beginning_of_time') }} ~ {{ endsAt() || t('features.vue.shared.filters.end_of_time') }}
  </oms-filter-content>
</template>

<script>
import OmsFilterContent from '../filter-content.vue'

export default {
  inject: ['i18n'],

  props: {
    title: String,
    modelValue: Object
  },

  components: {
    OmsFilterContent
  },

  methods: {
    t(key, options) {
      return this.i18n ? this.i18n.t(key, options) : key
    },
    startsAt() {
      if (!this.modelValue || !this.modelValue.starts_at) return

      return `${this.modelValue.starts_at} JST`
    },
    endsAt() {
      if (!this.modelValue || !this.modelValue.ends_at) return

      return `${this.modelValue.ends_at} JST`
    }
  }
}
</script>
